import $ from 'jquery';
import constants from 'Constants.js';
import Immutable from 'immutable';

import { View } from 'backbone';

import valueTemplate from 'properties/main/auto-start.ejs';


class MainAutoStartView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = valueTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=radio]': 'updateAttributes'
        };

        if (!this.model.get('autoStart')) {
            this.model.set('autoStart', "none", {silent: true});
        }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;

        this.model.set( propName, propVal );
    }



    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        $(":radio[value='"+this.model.get('autoStart')+"']").attr('checked', true);

        this.delegateEvents();
        return this;
    }

}

export default MainAutoStartView;
